module.exports = __webpack_public_path__ + "/images/logo-cta-murcia.bfe1faf.png";